import { render, staticRenderFns } from "./NotVip.vue?vue&type=template&id=c7a967fa&scoped=true&"
import script from "./NotVip.vue?vue&type=script&lang=js&"
export * from "./NotVip.vue?vue&type=script&lang=js&"
import style0 from "./NotVip.vue?vue&type=style&index=0&id=c7a967fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a967fa",
  null
  
)

export default component.exports